/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ open: NonNullable<unknown> }} Partner_Summary_Status_AlltimeInputs */



/**
* | output |
* | --- |
* | "{open} of it not yet invoiced" |
*
* @param {Partner_Summary_Status_AlltimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_summary_status_alltime = /** @type {((inputs: Partner_Summary_Status_AlltimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Summary_Status_AlltimeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`davon ${i?.open} noch nicht abgerechnet`)
	return /** @type {LocalizedString} */ (`${i?.open} of it not yet invoiced`)
});